import useCustomHook from '@/hooks/useCustomHook';
import { useContext, useEffect } from 'react';
import { GlobalContext } from '../GlobalContext/GlobalContext';
import { useRouter } from 'next/router';

export default function useLanguageSelector() {
  const globalContext = useContext(GlobalContext);
  const router = useRouter();

  const { state, actions } = useCustomHook({
    defaultState: {
      showSelector: false,
      selectedLanguage: 'es',
    },
    actions: {
      setSelectedLanguage: (selectedLanguage) => {
        globalContext.actions.setSelectedLanguage(selectedLanguage);
        if (router.pathname.includes('/library/')) {
          router.push('/library');
        }
      },
    },
  });

  useEffect(() => {
    if (globalContext.state.loaded) {
      actions.setState({
        showSelector: globalContext.state.availableLanguages.length > 1,
        selectedLanguage: globalContext.state.selectedLanguage,
      });
    }
  }, [globalContext.state.availableLanguages, globalContext.state.loaded]);

  useEffect(() => {
    actions.setState({
      selectedLanguage: globalContext.state.selectedLanguage,
    });
  }, [globalContext.state.selectedLanguage]);

  return { state, actions };
}
